import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import { UncontrolledTooltip } from "reactstrap";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCompanyTimeFormat } from "../../../utils/hooks/company";
import { firstToUpper } from "../../../utils/helpers/string";
import { getAvailabilityText } from "./helpers";

const ApprovedSnapshot = ({ id, snapshot }) => {
    const { t } = useTranslation();
    const timeFormat = useCompanyTimeFormat();

    const intervals = (snapshot?.intervals || []).filter((item) => item?.from && item?.to);

    return (
        <div className="p-3 d-flex align-items-center gap-3" style={{ border: "1px dashed #d5d5d1" }}>
            <UncontrolledTooltip target={id}>{t("approved")}</UncontrolledTooltip>
            <span id={id}>
                <FontAwesomeIcon icon={faCircleCheck} className="text-lg text-green" />
            </span>
            <div className="d-flex gap-2 align-items-center flex-wrap">
                <span>{getAvailabilityText(snapshot, t)}</span>
                {snapshot?.reason ? (
                    <span className="font-weight-bolder">
                        {t("reason")}: <span className="font-weight-normal">{snapshot.reason}</span>
                    </span>
                ) : null}
                {intervals.length > 0 ? (
                    <div className="d-flex flex-column">
                        {intervals.map((item, i) => (
                            <div key={i} className="d-flex">
                                <div className="d-flex align-items-center">
                                    <span className="mx-2 my-0 font-weight-bolder">{t("from")}:</span>
                                    <span>{moment.parseZone(item.from).format(timeFormat)}</span>
                                </div>
                                <div className="d-flex align-items-center">
                                    <span className="mx-2 my-0 font-weight-bolder">{firstToUpper(t("to"))}:</span>
                                    <span>{moment.parseZone(item.to).format(timeFormat)}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default ApprovedSnapshot;
